    // نقشه جامع رنگ‌ها - دسترسی سریع O(1)
const COLORS_MAP = {
    'white-matte': 'سفید مات',
    'black-matte': 'مشکی مات',
    'steel-matte': 'استیل مات',
    'titanium':    'تیتانیوم',
    'gold':        'طلایی',
    'brushed':     'خشدار',
    'chrome':      'کروم',
    'black':       'مشکی',
    'gold-shiny':  'طلایی براق',
    'gold-matte':  'طلایی مات',
    'grey-matte':  'طوسی مات',
    'grey':        'طوسی',
    'cream':       'کرم',
    'white':       'سفید',
    'aluminum':    'آلومینیوم',
    'mocha':       'موکا',
    'steel':       'استیل',
    'silver':      'نقره‌ای',
    'grey-metallic': 'طوسی متالیک',
    'grey-light':  'طوسی روشن',
    'nescafe':     'نسکافه',
    'grey-dark':   'طوسی تیره',
    'orange':      'نارنجی',
    'vanilla':     'وانیلی',
    'green':       'سبز',
    'red':         'قرمز',
    'steel-grey':  'استیل طوسی',
    'steel-white': 'استیل سفید',
};

/**
 * لیست کامل جهت رندر در UI (مثل انتخابگر رنگ)
 */
export const colors = Object.entries(COLORS_MAP).map(([code, title]) => ({
    code,
    title,
    linear: `var(--bg-color-${code})`,
    tw: `bg-[--bg-color-${code}]`
}));

/**
 * دریافت اطلاعات کامل یک رنگ
 * @param {string} code - کد رنگ
 */
export const getColor = (code) => {
    if (!code) return null;
    const normalizedCode = String(code).toLowerCase().trim().replace(/\s+/g, '-');
    const title = COLORS_MAP[normalizedCode];
    if (!title) return null;
    return {
        title,
        linear: `var(--bg-color-${normalizedCode})`,
        tw: `bg-[--bg-color-${normalizedCode}]`
    };
};

/**
 * دریافت گرادینت خطی (CSS variable)
 * @param {string} code - کد رنگ
 */
export const getColorLinear = (code) => {
    if (!code) return 'transparent';
    const normalizedCode = String(code).toLowerCase().trim().replace(/\s+/g, '-');
    return `var(--bg-color-${normalizedCode})`;
};
